import * as uploadActions from '../../common/actions/uploadActions';
import client from '../../common/graphql/apollo';
import {
  addMediaToSlideMutation,
  removeMediaFromSlideMutation,
} from '../../common/graphql/mutations';

/**
 * Upload the provided file, and attach it to the slide with id slideId
 *
 * @param file
 * @param slideId
 */
export const addMediaToSlide = (file, slideId) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch(uploadActions.uploadFile(file))
      .then(fileData =>
        client.mutate({
          mutation: addMediaToSlideMutation,
          variables: { file: fileData.id, slide: slideId },
        }),
      )
      .then(result => {
        const { success, media } = result.data.addMediaToSlide;

        if (success) {
          dispatch({ type: 'ADD_MEDIA', slideId, media });
          resolve();
        } else {
          reject(new Error('Error while adding media to slide'));
        }
      })
      .catch(reject);
  });

/**
 * Remove the media attached to the slide with id slideId
 *
 * @param slideId
 */
export const removeMediaFromSlide = slideId => dispatch =>
  new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: removeMediaFromSlideMutation,
        variables: { slide: slideId },
      })
      .then(result => {
        const { success } = result.data.removeMediaFromSlide;

        if (success) {
          dispatch({ type: 'DELETE_MEDIA', slideId });
          resolve();
        } else {
          reject(new Error('Error while removing media from slide'));
        }
      })
      .catch(() => {
        reject(new Error('Error while removing media from slide'));
      });
  });
